import { Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import StockLocationControlService from "./StockLocationControlService";
import DefaultChip from "../../componentes/chip/DefaultChip";
/**
 * Author : AndréK
 * 26/08/2022
*/
const columns = (t) => [
    { field: "idStorage", flex: 0.5, visible: false },
    {
        field: "storage",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="storage" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.storage}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status == 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];
export const StockLocationStorage = ({ idClient }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        idStorage: 0,
        storage: "",
        rows: [],
        userId: userId,
        status: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [StockLocation, dispatch] = useReducer(reducer, initialState);

    const { idStorage, storage, status } = StockLocation
    const { success, error, rows, ...data } = StockLocation

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }

    const handleSearch = () => {
        StockLocationControlService
            .getStockLocationStorage(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const canSave = () => storage !== "";

    const handleSaveUpdate = () => {
        if (canSave()) {
            
            StockLocationControlService
                .createStockLocationStorage(data)
                .then((response) => {
                    if (response.status === 200) {
                        dispatch({ type: 'update', data: { success: true, error: false, idStorage: response.data.idStorage } })
                        handleSearch();
                    }
                })
                .catch((e) => dispatch({ type: 'error' }));
            
        } else {
            dispatch({ type: 'error' })
        }
    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                idStorage: data.idStorage,
                storage: data.storage,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])


    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={4} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="address" labelName="storage" />
                                }
                                name="storage"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={storage}
                                inputProps={{ maxLength: 10 }}
                                error={error && storage === ""}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={2} md={2}>
                            <DefaultAutocomplete
                                name={"status"}
                                onChange={handleChange}
                                value={status}
                                label={t("status")}
                                defaultSize
                                items={[
                                    { id: 0, name: t("canceled"), status: 1 },
                                    { id: 1, name: t("active"), status: 1 },
                                    { id: 2, name: t("all"), status: 1 },
                                ]}
                                error={error && status === 2}
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSearch={handleSearch}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        onClickSave={handleSaveUpdate}
                    />
                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}